import VueCookies from 'vue-cookies';
import { FixedSeries } from '@/js/model/DataSeries';


/**
 * Vuex Mutations (Synchronous)
 */
export const mutations = {
  unload: state => state.isLoaded = false,
  loaded: state => state.isLoaded = true,
  selectLabels: (state, label) => state.label = label,

  updateTitle: (state, text) => state.modelTitle = text,
  updateDescription: (state, text) => state.modelDescription = text,
  updateModelID (state, id) {
    state.modelID = id;
    state.updateKey = VueCookies.get(`${id}:update-key`);
  },

  /**
   * Add an adjustment component on top of the desired component
   *   this creates a new component, using the existing node as
   *   input, and redirects outputs to come from the adjusted
   *   component
   * 
   * @param {{
   *   overwriteLabel: string?
   * }} payload
   */
  addAdjustment(state, payload = {}) {
    let baseLabel = payload.overwriteLabel ?? state.label;

    if (Array.isArray(baseLabel)) {
      console.log('Multiple adjustments not supported');
      return;
    }
    if (baseLabel.startsWith('Adj ')) {
      console.log('Cannot add adjustment on top of adjustment');
      return;
    }

    let adjustmentLabel = `Adj ${baseLabel}`;
    let newNodeLabel = `${baseLabel}*`;

    try {
      state.model.addComponentAdjustment(baseLabel, adjustmentLabel);
      state.model.nodes.addToNode(newNodeLabel, [baseLabel, adjustmentLabel]);
      state.model.recalculate();

      this.commit('selectLabels', [baseLabel, adjustmentLabel]);
    } catch (err) {
      console.log('Adjustment component already exists or can\'t be created');
      return;
    }
  },


  /**
   * 
   * @param {{
   *   method: Function,
   *   parameters: Object,
   *   overwriteLabel: string?
   * }} payload
   */
  updateMethod(state, payload) {
    let component = state.model.getComponent(payload.overwriteLabel ?? state.label);
    if (payload.parameters) {
      component.updateMethod(payload.method, payload.parameters);
    } else {
      component.updateMethod(payload.method, component.inputMapping.inputMapping);
    }
    state.model.recalculate();
  },


  /**
   * 
   * @param {{
   *   inputParameters: any[],
   *   overwriteLabel: string?
   * }} payload
   */
  updateScenario(state, payload) {
    let component = state.model.getComponent(payload.overwriteLabel ?? state.label);
    component.scenarios = [payload.inputParameters];
    state.model.recalculate();
  },


  /**
   * 
   * 
   * @param {{
   *   key: string,
   *   value: number,
   *   overwriteLabel: string?
   * }} payload
   */
  updateInputMapping(state, payload) {
    let {key, value} = payload;
    let component = state.model.getComponent(payload.overwriteLabel ?? state.label);
    component.inputMapping.changeInput(key, value);
    state.model.recalculate();
  },


  /**
   * Set the entire Vuex state
   */
  setState(state, payload) {
    state.modelID = payload.modelID;
    state.modelTitle = payload.modelTitle;
    state.modelDescription = payload.modelDescription;
    state.model = payload.model;
    state.label = state.model.components[0].label;
    state.isLoaded = payload.isLoaded ?? true;
  },


  /**
   * Override the current data value of the series [ONLY FOR FIXEDSERIES NOW]
   * 
   * @param {*} state 
   * @param {{
   *   value: number,
   *   overwriteLabel: string?
   * }} payload
   */
  overrideDataValue(state, payload) {
    let component = state.model.getComponent(payload.overwriteLabel ?? state.label);
    let data = component.data;

    if (data instanceof FixedSeries) {
      data.push(payload.newValue);
    }
    state.model.recalculate();
  },


  /**
   * Recalculate each of the model's components
   */
  recalculate(state) {
    state.model.recalculate();
  }
};